module.exports = __webpack_public_path__ + "static/media/bar-chart.dbc4c63d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bar-chart.svg
// module id = 2185
// module chunks = 0